import { render } from "./item.vue?vue&type=template&id=d918df7e&scoped=true"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"

import "./item.vue?vue&type=style&index=0&id=d918df7e&lang=scss&scoped=true"

import exportComponent from "/builds/gitlab-runner/ci/auto-build/hospital-user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d918df7e"]])

export default __exports__